import { GetSignedUrlsParams, GetSignedUrlsResponse } from '.';
import axios, { AxiosProgressEvent } from 'axios';
import { EXPRESS_API } from 'configs/api/expressApi';

export const getSignedURLs = async (
  data: GetSignedUrlsParams
): Promise<GetSignedUrlsResponse> => {
  const response = await EXPRESS_API.post('/aws/signedurl/user-images', data);
  return response.data;
};

export const uploadAttachmentExpress = async (
  file: FormData,
  progressUpdate?: (total: number, uploaded: number, percent: number) => void,
  abortSignal?: AbortSignal
) => {
  const response = await EXPRESS_API.post('/aws/attachments', file, {
    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
      if (!progressEvent.total) return;
      const progress = progressEvent.loaded / progressEvent.total;
      const pct = parseFloat(progress.toFixed(2)) * 100;
      if (progressUpdate !== undefined)
        progressUpdate(progressEvent.total, progressEvent.loaded, pct);
    },
    signal: abortSignal,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const isCanceled = axios.isCancel(response);
  if (isCanceled) {
    throw response;
  }
  return response.data;
};

export const removeAttachmentExpress = async (fileName: string) => {
  await EXPRESS_API.delete(`/aws/attachments/${fileName}`);
};
